var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarDone16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#star_done_16-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.77 1.778c.396-.801.593-1.201.861-1.33a.857.857 0 0 1 .738 0c.268.129.466.529.861 1.33l1.054 2.136c.117.236.175.354.26.446.052.055.11.103.174.143l-.435.435a2.572 2.572 0 0 0-3.53 3.737l1.715 1.715a2.571 2.571 0 0 0 3.636 0l.221-.22.01.052.402 2.348c.15.88.226 1.32.084 1.58a.857.857 0 0 1-.597.434c-.292.055-.687-.153-1.477-.569l-2.108-1.108c-.234-.123-.35-.184-.474-.208a.86.86 0 0 0-.33 0c-.123.024-.24.085-.473.208l-2.108 1.108c-.79.416-1.185.624-1.478.57a.857.857 0 0 1-.597-.434c-.141-.261-.066-.701.085-1.581l.403-2.348c.044-.26.067-.39.051-.514a.857.857 0 0 0-.101-.314c-.061-.11-.156-.202-.345-.386L1.567 7.346c-.64-.624-.96-.935-.998-1.23a.857.857 0 0 1 .228-.702c.204-.215.646-.28 1.53-.408l2.357-.342c.26-.038.391-.057.505-.11a.857.857 0 0 0 .267-.194c.085-.092.144-.21.26-.446l1.055-2.136Zm8.694 2.828a.857.857 0 0 0-1.213-1.212l-3.965 3.965-1.108-1.108a.857.857 0 0 0-1.212 1.212L9.68 9.178a.857.857 0 0 0 1.212 0l4.572-4.572Z",
    fill: "#B0B2B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star_done_16-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarDone16);
export default __webpack_public_path__ + "static/media/star_done_16.efbedc84.svg";
export { ForwardRef as ReactComponent };